var _excluded = ["themeColor"];
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import { AppBarSection, AppBarSpacer, AppBar as KendoAppBar } from '@progress/kendo-react-layout';
import PropTypes from 'prop-types';
import React from 'react';
import styled, { css } from 'styled-components';
var StyledAppBar = styled(_ref => {
  var {
      themeColor
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(KendoAppBar, _extends({}, rest, {
    themeColor: ['base', 'secondary'].includes(themeColor) ? 'light' : themeColor
  }));
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    ", "\n"])), props => css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        ", "\n        ", "\n        ", "\n        box-shadow: none;\n        padding: 0.5rem 1rem;\n    "])), props.themeColor === 'base' && css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n            background-color: ", ";\n        "])), props.theme.component.baseBg), props.themeColor === 'secondary' && css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n            background-color: ", ";\n        "])), props.theme.component.secondaryBg), props.borderless ? css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n            border-width: 0;\n        "]))) : css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n            border-color: ", ";\n            border-width: 0 0 1px;\n        "])), props.theme.component.baseBorder)));

/**
 * The AppBar provides information and actions related to the current
 * application screen. It is typically used to show page titles, brand
 * identity and can contain navigation items.
 */
var AppBar = props => /*#__PURE__*/React.createElement(StyledAppBar, props);
AppBar.defaultProps = {
  borderless: false,
  children: undefined,
  className: undefined,
  id: undefined,
  position: 'top',
  positionMode: 'static',
  themeColor: 'base',
  style: undefined
};
AppBar.propTypes = {
  /**
   * Determines if the AppBar is borderless.
   */
  borderless: PropTypes.bool,
  /**
   * Represents the children that are passed to the AppBar.
   */
  children: PropTypes.node,
  /**
   * Sets additional CSS classes to the AppBar.
   */
  className: PropTypes.string,
  /**
   * Sets the `id` property of the root AppBar element.
   */
  id: PropTypes.string,
  /**
   * Specifies the position of the AppBar.
   * The possible values are: 'top' | 'bottom'
   */
  position: PropTypes.oneOf(['bottom', 'top']),
  /**
   * Specifies the positionMode of the AppBar.
   * The possible values are: 'static' | 'sticky' | 'fixed'
   */
  positionMode: PropTypes.oneOf(['static', 'sticky', 'fixed']),
  /**
   * Sets additional CSS styles to the AppBar.
   * (React.CSSProperties)
   */
  style: PropTypes.shape({}),
  /**
   * Specifies the theme color of the AppBar.
   * The possible values are: 'base' | 'dark' | 'inherit' | 'light' | 'secondary'
   */
  themeColor: PropTypes.oneOf(['base', 'dark', 'inherit', 'light', 'secondary'])
};
export default AppBar;
export { AppBarSection, AppBarSpacer };